<template>
  <span :class="styleClass" v-if="styleClass == 'member-classes-period-type'">
    {{ CoursePeriodsType.getValue(periods_type) }}
  </span>
  <span :class="styleClass" v-else>
    【{{ CoursePeriodsType.getValue(periods_type) }}】
  </span>
</template>

<script>
import { CoursePeriodsType } from "@/utils/enums";
export default {
  name: "CoursePeriodsType",
  props: {
    periods_type: {
      require: true,
    },
    styleClass: {
      type: String,
      default: "member-classes-period-type",
    },
  },
  data() {
    return {
      CoursePeriodsType,
    };
  },
};
</script>

<style>
.member-classes-period-type {
  padding: 1px 7px;
  font-size: 12px;
  color: #bb1c20;
  background: #ffffff;
  border: 1px solid #bb1c20;
  border-radius: 12px;
  margin-right: 12px;
  white-space: nowrap;
}
</style>
